import { parsePhoneNumberFromString, CountryCode } from "libphonenumber-js";

export function validatePhone(
  value: string | undefined,
  countryCode: CountryCode,
  isRequired?: boolean,
  requiredMessage = "Phone number is required",
  invalidMessage = "Invalid phone number",
): string | true {
  const trimmed = value?.trim();

  if (!trimmed) return isRequired ? requiredMessage : true;

  const phone = parsePhoneNumberFromString(trimmed, countryCode);
  return phone?.isValid() ? true : invalidMessage;
}

export function formatPhone(
  phone: string,
  countryCode: CountryCode,
  format: "national" | "international" | "e164" = "international",
): string {
  const parsed = parsePhoneNumberFromString(phone, countryCode);
  if (!parsed?.isValid()) return phone;

  if (format === "national") return parsed.formatNational();
  if (format === "e164") return parsed.format("E.164");
  return parsed.formatInternational();
}

export default validatePhone;
